import { FC } from "react";
import BannerCard from "@Components/BannerCard/BannerCard";
import PersonalSummary from "@Components/PersonalSummary/PersonalSummary";
import { NextArrowIcon } from "@Icons/MainIcons";
import { useTranslation } from "react-i18next";

const GuestSummaryTrigger: FC<{ guestItems: any[]; onClick?: () => void }> = ({ guestItems, onClick }) => {
  const { t } = useTranslation();

  return (
    <BannerCard
      className="rounded-md! rounded-e-xl! flex cursor-pointer justify-between p-4 shadow-sm"
      rootClassName="bg-background-primary! ps-1! rounded-2xl! rounded-s-lg!"
      onClick={onClick}
    >
      <PersonalSummary
        title={<div className="font-semibold">{t("Hotels.guests.guestDetails")}</div>}
        items={guestItems}
        nameOverflowCount={1}
        imgOverflowCount={2}
        classNames={{
          chipTitle: "font-semibold! text-sm!",
          root: "gap-2!",
          chipInfo: "gap-0.5!",
        }}
        chipSubtitle={(items) => (
          <div className="font-semibold! text-[.65rem]">
            {items.length === 1 ? t("Hotels.common.oneGuest") : t("Hotels.common.guestsCount", { count: items.length })}
          </div>
        )}
      />
      <div className="text-icon-disabled">
        <NextArrowIcon className="w-3" />
      </div>
    </BannerCard>
  );
};

export default GuestSummaryTrigger;
